/* eslint-disable no-unused-vars */
import { Avatar, Box, Flex, Typography } from "../../ppui";
import { formatIndianCurrency } from "../../utils/common";

export const headers = (currentPage, rowsPerPage) => [
  { 
    key: "salary_id", 
    label: "SL No.", 
    isShortable: true, 
    isVisible: true,
    getValue: (row, index) => currentPage * rowsPerPage + index + 1,
  },
  {
    key: "employee_name",
    label: "Employee Name",
    isClickable: true,
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (rows,) => (
      <>
        <Flex alignItems="center" >
          <Avatar
            className={"avatarHover"}
            size="xs"
            color="secondary"
            initials={`${rows.employee_name.trim().substring(0, 1).toUpperCase()}`} 
            sx={{ marginInlineEnd: "0.625rem" }}
          />
          <Box >
            
            {rows.employee_name}
            <Typography
              color={"default"}
              colorVariant={"light"}
              variant={"body3"}
              mb={"0"}
            >
              #{rows.employee_code}
            </Typography>
          </Box>
        </Flex>
      </>
    ),
  },

  { key: "month_days", label: "Salary Type", align: "left", isShortable: true,  getValue: (row) => row?.employees?.employee_benefits?.[0]?.salary_type , },
  { key: "month_days", label: "Month Days", align: "left", isShortable: false,  isVisible: false, },
  { key: "payable_days", label: "Payable Days", align: "left", isShortable: true, isVisible: true,  
    getValue: (row) => row?.payable_days ?? 0,

  },
  { key: "ncp_days",
    label: "NCP Days", 
    align: "left", 
    isShortable: false,
    isVisible: false,
    getValue: (row) => row?.ncp_days ?? 0,
  },
  { 
    key: "CTC_salary", 
    label: "CTC", 
    align: "right", 
    isShortable: true,
    isVisible: true, 
    getValue: (row) => row?.CTC_salary ? formatIndianCurrency(row?.CTC_salary.toFixed()) : 0, 
  },
  { 
    key: "payable_basic_salary",
    label: "Basic Salary",
    align: "right",
    isShortable: true,
    isVisible: true,  
    getValue: (row) => row?.payable_basic_salary ? formatIndianCurrency(row?.payable_basic_salary.toFixed()) : 0,
  },
  { key: "allowance", label: "Allowance", align: "right", isShortable: false,isVisible: false, getValue: (row) =>{
    const totalAllowance = row.allowance.reduce((sum, allowance) => sum + allowance.allowance_value, 0);
    return formatIndianCurrency(totalAllowance.toFixed());
} },
  { key: "gross_salary", label: "Gross Salary", align: "right",isShortable: true,isVisible: true, getValue: (row, ) => formatIndianCurrency(Number(row?.gross_salary).toFixed())},
  { key: "ot_amount", label: "OT Amount", align: "right",isShortable: false,isVisible: "", getValue: (row, ) =>formatIndianCurrency(Number( row?.ot_amount).toFixed()) },
  { key: "bonus_amount", label: "Bonus", align: "right", isShortable: false,isVisible: "", getValue: (row, ) =>formatIndianCurrency(Number( row?.bonus_amount).toFixed()) },
  { key: "incentive_amount", label: "Incentive", align: "right", isShortable: false, isVisible: "",getValue: (row, ) =>formatIndianCurrency(Number( row?.incentive_amount).toFixed()) },
  { key: "gross_arrear", label: "Gross Arrear", align: "right", isShortable: false,isVisible: "", getValue: (row, ) =>formatIndianCurrency(Number( row?.gross_arrear).toFixed()) },
  { key: "otherearning", label: "Other Earnings", align: "right", isShortable: false,isVisible:"",getValue: (row, ) =>formatIndianCurrency(Number( row?.any_other_amt).toFixed())  },
  { key: "earning_salary", label: "Total Earnings", align: "right", isShortable: false, isVisible:false,getValue: (row, ) => formatIndianCurrency(Number(row?.earning_salary).toFixed())},
  { key: "epf_amount", label: "EPF", align: "right", isShortable: false,isVisible:false, getValue: (row, ) =>formatIndianCurrency(Number( row?.epf_amount).toFixed())   },
  { key: "esi_amount", label: "ESI", align: "right", isShortable: false,isVisible:false,getValue: (row, ) =>formatIndianCurrency(Number( row?.esi_amount).toFixed())   },
  { key: "pTaxAmount", label: "P-TAX", align: "right", isShortable: false,isVisible:false,getValue: (row, ) =>formatIndianCurrency(Number( row?.pTaxAmount).toFixed())    },
  { key: "canteen", label: "Canteen", align: "right", isShortable: false,isVisible:"",getValue: (row, ) =>formatIndianCurrency(Number( row?.canteen).toFixed())    },
  { key: "tds", label: "TDS", align: "right", isShortable: false,isVisible:"",getValue: (row, ) =>formatIndianCurrency(Number( row?.tds).toFixed())    },
  { key: "advance_amount", label: "Advance Amount", align: "right", isShortable: false,isVisible:"",getValue: (row, ) =>formatIndianCurrency(Number( row?.advance_amount).toFixed())   },
  { key: "loan_advance", label: "Loan Emi", align: "right", isShortable: false,isVisible:"",getValue: (row, ) =>formatIndianCurrency(Number( row?.loan_advance).toFixed())   },
  { key: "epf_arrear", label: "EPF Arrear", align: "right", isShortable: false,isVisible:"",getValue: (row, ) =>formatIndianCurrency(Number( row?.epf_arrear).toFixed())   },
  { key: "esic_arrear", label: "ESI Arrear", align: "right", isShortable: false,isVisible:"",getValue: (row, ) =>formatIndianCurrency(Number( row?.esic_arrear).toFixed())   },
  { key: "any_other_deduction", label: "Other Deduction", align: "right", isShortable: false,isVisible:"",getValue: (row, ) => formatIndianCurrency(Number(row?.any_other_deduction).toFixed())  },
  // { key: "total_deduction", label: "Total Deduction", align: "right", isShortable: false,isVisible:false,getValue: (row, index) => 
  //   Math.round(
  //       Number(
  //          formatIndianCurrency(Number( row?.total_deduction).toFixed()) + 
  //           row?.canteen + 
  //           row?.advance_amount + 
  //           row?.epf_arrear + 
  //           row?.esic_arrear + 
  //           row?.any_other_deduction +
  //           row?.loan_advance 
  //       )
  //   ) },
  // { key: "payable_salary", label: "Net Payable Salary", align: "right",   isShortable: true,isVisible:true,getValue: (row, index) => row?.payable_salary - row?.loan_advance  },


  { key: "total_deduction", label: "Total Deduction", align: "right", isShortable: false,isVisible:false,getValue: (row) => 
    // Math.round(
        formatIndianCurrency(Number(row?.total_deduction).toFixed())
     },
  {
    key: "payable_salary",
    label: "Net Payable",
    align: "right",
    isShortable: true,
    isVisible: true,
    getValue: (row) => {
      return formatIndianCurrency(Number(row?.payable_salary).toFixed());
    }
  },
  {
    key: "remarks",
    label: "Remarks",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {
      const joinDate = row?.employees?.join_date ? new Date(row.employees.join_date) : null;
      const exitDate = row?.employees?.exit_formalities?.[0]?.exit_date ? new Date(row?.employees?.exit_formalities?.[0]?.exit_date) : null;

      const recordMonth = row?.month;  
      const recordYear = row?.year;   
  
      if (joinDate && joinDate.getMonth() + 1 === recordMonth && joinDate.getFullYear() === recordYear) {
        return `The Employee joined on ${joinDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
      }
  
      if (exitDate && exitDate.getMonth() + 1 === recordMonth && exitDate.getFullYear() === recordYear) {
        return `Employee exited at ${exitDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
      }
  
      return row?.remarks || "--";
    }
  },
];


